import React from "react";
import MySwal from "sweetalert2";
import {useTranslation} from "react-i18next";

// Icons
import MailOutline from "react-ionicons/lib/IosMailOutline";
import CallOutline from "react-ionicons/lib/IosCallOutline";
import WhatsAppOutline from "../../assets/images/logos/logo-whatsapp.svg";

// CSS Files
import "./styles.css";

const ContactsList = (props) => {
   const { t } = useTranslation();
   const isDesktop = () => {
      return window.innerWidth > 767;
   }

   const showPhone = (number) => {
      if (isDesktop()) {
         MySwal.fire({
            allowOutsideClick: true,
            titleText: t("common.form.labels.phone_number"),
            text: number === "" || number === null ? t("to_schedule_page.no_phone_number") : `${number}`
         });
      }
   }

   const showEmail = (email) => {
      if (isDesktop()) {
         MySwal.fire({
            allowOutsideClick: true,
            titleText: t("common.form.labels.email"),
            text: `${email}`
         });
      }
   }

   return <div className={"d-flex flex-grow-1 justify-content-end align-items-center"}>
      <a href={isDesktop() ? undefined : `mailto:${props.email}`} className={(isDesktop() ? "cursor-pointer" : "")}>
         <MailOutline fontSize="30px" onClick={() => showEmail(props.email)}/>
      </a>
      {props.phoneNumber &&
         <>
            <a href={isDesktop() ? undefined : `tel:${props.phoneNumber}`} className={"ml-2" + (isDesktop() ? " cursor-pointer" : "")}>
               <CallOutline fontSize="30px" onClick={() => showPhone(props.phoneNumber)}/>
            </a>
            <a href={`https://wa.me/${props.phoneNumber.startsWith('00') ? props.phoneNumber.replace(/^00/, '') : props.phoneNumber}`} target={"_blank"}>
               <img src={WhatsAppOutline} alt={"whatsapp logo"} className={"ml-2 mr-1 logo-whatsapp"}/>
            </a>
         </>
      }
   </div>
}

export default ContactsList;